import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { withRouter } from "react-router";
import { Label, Input, Loader, Select, Utils } from "arv-reactcomponents";
import {
  setLastUsedPincode,
  getlastUsedPincode,
  getFilterUrl,
  queryParamsToObject,
  isDesktop,
} from "../../../../utils";
import Analytics from "../../../../analytics";
import Event from "../../../../analytics/eventFactory";

@withRouter
@inject("ProductStore")
@observer
class OmniFilter extends Component {
  static getList(item) {
    return (
      <li className="nw-omnifilter-dropdown" key={item}>
        {item}
      </li>
    );
  }
  static getDefaultRadius(propRaduis, search, defaultVal) {
    const queryObj = queryParamsToObject(search);
    const raduisFromSearch = (parseInt(queryObj.r, 10) && queryObj.r) || "";
    return raduisFromSearch || propRaduis || defaultVal;
  }
  static getDefaultPincode(type, propCache, search) {
    const pincodeFromCache = propCache[type] || "";
    const pincodeFromStorage = getlastUsedPincode();
    const queryObj = queryParamsToObject(search);
    const key = type === "nearby_stores" ? "p-st" : "p-dl";
    const pincodeFromSearch = queryObj[key] || "";
    if (pincodeFromSearch && pincodeFromSearch !== pincodeFromStorage) {
      setLastUsedPincode(pincodeFromSearch);
    }
    return pincodeFromSearch || pincodeFromCache || pincodeFromStorage;
  }
  constructor(props) {
    super(props);
    const sortByValsList = ["1", "3", "5", "10", "20"];
    this.state = {
      pincode: OmniFilter.getDefaultPincode(
        props.type,
        props.ProductStore.omniPincodeCache,
        window.location.search,
      ),
      showLoader: false,
      sortBySelected: OmniFilter.getDefaultRadius(
        props.ProductStore.omniPincodeCache.radius,
        window.location.search,
        sortByValsList[4],
      ),
      sortByVals: sortByValsList,
      pincodeErrorMessage: "",
    };
    this.validatePincode = this.validatePincode.bind(this);
    this.update = this.update.bind(this);
    this.getSortSelection = this.getSortSelection.bind(this);
    this.triggerSearch = this.triggerSearch.bind(this);
    this.initOmni = this.initOmni.bind(this);
    this.type = props.type;
    this.loading = false;
  }
  componentWillMount() {
    if (!this.loading && !this.state.pincodeErrorMessage) {
      this.initOmni();
    }
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.list &&
      nextProps.list.length === 0 &&
      !this.loading &&
      !this.state.pincodeErrorMessage
    ) {
      this.initOmni(true);
    }
  }

  get showLoader() {
    return this.state.showLoader ? "nw-omnifilterloader" : "nwc-hide";
  }

  getSortSelection(value) {
    const sortBySelected = parseInt(value, 10);
    this.setState({
      sortBySelected,
    });
    const { ProductStore } = this.props;
    const { pincode } = this.state;
    const radiusFromStore = ProductStore.omniPincodeCache.radius;
    if (radiusFromStore !== sortBySelected) {
      ProductStore.storeOmniPincode("radius", sortBySelected);
      if (pincode) {
        const obj = {
          target: {
            value: this.state.pincode,
          },
        };
        this.validatePincode(obj, true);
      }
    }
  }
  initOmni(forceReload) {
    const { ProductStore } = this.props;
    const pincode =
      ProductStore.omniPincodeCache[this.type] || getlastUsedPincode();
    if (pincode) {
      const { list } = this.props;
      if (!list || list.length === 0 || forceReload) {
        this.update(pincode);
      }
    }
  }
  validatePincode(e, forceReload) {
    const validatePincode = this.validatePincodedRef.getValidatedOutput(
      e.target.value,
    );
    const { ProductStore } = this.props;
    if (validatePincode.isValid) {
      this.setState({
        pincode: validatePincode.value,
        pincodeErrorMessage: "",
      });
      if (
        validatePincode.value.length === 6 &&
        (ProductStore.omniPincodeCache[this.type] !== validatePincode.value ||
          forceReload)
      ) {
        this.update(validatePincode.value);
      }
    } else {
      this.setState({
        pincode: validatePincode.value,
        pincodeErrorMessage: validatePincode.errorMsg,
      });
    }
  }
  update(pincodeToBeUpdated) {
    const { ProductStore } = this.props;
    const location = isDesktop
      ? this.props.location
      : ProductStore.mobileTempUrlCache;
    const { pathname, search } = location;
    setLastUsedPincode(pincodeToBeUpdated);
    ProductStore.storeOmniPincode(this.type, pincodeToBeUpdated);
    const deliveryPincode =
      ProductStore.omniPincodeCache.delivery_time ||
      ProductStore.omniPincodeCache.nearby_stores;
    const storePincode =
      ProductStore.omniPincodeCache.nearby_stores ||
      ProductStore.omniPincodeCache.delivery_time;
    const { radius } = ProductStore.omniPincodeCache;
    let setUrlParameter = getFilterUrl(
      { value: deliveryPincode },
      "p-dl",
      search,
    );
    setUrlParameter = getFilterUrl(
      { value: storePincode },
      "p-st",
      setUrlParameter,
    );
    setUrlParameter = getFilterUrl({ value: radius }, "r", setUrlParameter);
    const newUrl = `${pathname}?${setUrlParameter}`;

    this.setState({ showLoader: true });
    this.loading = true;
    Analytics.trackEvent({
      action:
        this.type === "nearby_stores"
          ? Event.action.STORE_PINCODE
          : Event.action.DELIVERY_PINCODE,
      label:
        this.type === "nearby_stores"
          ? `${pincodeToBeUpdated}_${radius}`
          : `${pincodeToBeUpdated}`,
      category: Event.category.LISTING_PAGE,
    });
    ProductStore.getOmniData(newUrl, this.type).then(data => {
      this.loading = false;
      if (data && data[this.type] && data[this.type].length > 0) {
        this.setState({ showLoader: false });
        this.props.rerenderFilter();
      } else {
        const errorMessage =
          this.type === "nearby_stores"
            ? "No Stores Found"
            : "No delivery options";
        this.setState({
          showLoader: false,
          pincodeErrorMessage: errorMessage,
        });
      }
    });
  }
  triggerSearch(event) {
    const key = event.which || event.keyCode;
    if (key === 13) {
      event.preventDefault();
    }
    const obj = {
      target: {
        value: this.state.pincode,
      },
    };
    this.validatePincode(obj, true);
  }
  render() {
    const { pincode } = this.state;
    const { eachfilterBy, placeholder, className } = this.props;
    const { sortBySelected, sortByVals } = this.state;
    if (!eachfilterBy) return null;

    return (
      <div className="nw-omnifilter">
        {this.type &&
          this.type === "nearby_stores" && (
            <div className={`nw-storefilter-selectwrap ${className}`}>
              <span>Stores within</span>
              <Select
                className="nwc-select-secondary nwc-select-xs nw-storefilter-select"
                selectedValue={sortBySelected}
                inpList={sortByVals}
                getSelection={this.getSortSelection}
                renderList={OmniFilter.getList}
              />
              <span>kms of</span>
            </div>
          )}

        <Label
          className="nw-omnifilter-inputlabel"
          htmlFor="nw-omnifilter-input"
        >
          <Input
            id="nw-omnifilter-input"
            className="nw-omnifilter-input"
            onChange={this.validatePincode}
            placeholder={placeholder}
            type="tel"
            onKeyPress={this.triggerSearch}
            value={pincode}
            ref={values => {
              this.validatePincodedRef = values;
            }}
            maxLength={6}
            validateWithPattern={[
              {
                pattern: /^((\d+)*)?$/,
                msg: "Pincode must be a number",
              },
            ]}
          />
          <i
            role="button"
            className="icomoon-search3 nw-omnifilter-icon"
            onClick={this.triggerSearch}
            tabIndex="0"
            onKeyPress={Utils.noop}
          />
        </Label>
        <div className={`nw-omnifiltererror ${className}`}>
          {this.state.pincodeErrorMessage}
        </div>
        <div className={`${this.showLoader}`}>
          <Loader />
        </div>
      </div>
    );
  }
}
OmniFilter.defaultProps = {
  className: "",
  rerenderFilter: Utils.noop,
};

OmniFilter.wrappedComponent.propTypes = {
  rerenderFilter: PropTypes.func,
  className: PropTypes.string,
  type: PropTypes.string.isRequired,
  list: PropTypes.oneOfType([
    PropTypes.shape({}).isRequired,
    PropTypes.shape([]).isRequired,
  ]).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
  }).isRequired,
  ProductStore: PropTypes.shape({
    getOmniData: PropTypes.func.isRequired,
    omniPincodeCache: PropTypes.shape().isRequired,
  }).isRequired,
  eachfilterBy: PropTypes.shape({
    pincodeDetails: PropTypes.shape({
      pincode: PropTypes.string,
    }),
  }).isRequired,
  placeholder: PropTypes.string.isRequired,
};

export default OmniFilter;



// WEBPACK FOOTER //
// ./src/component/ProductFilters/ProductFilterBlock/OmniFilter/index.js